<!--  -->
<template>
  <div>
    <div class="cont_r_b11">
      <p>
        <img :src="images.lglz">&nbsp;
      </p>
      <p>
        <br>
      </p>
      <p>
        <b>
          <span style="font-size:16.0pt;font-family:宋体;">
            <br>
          </span>
        </b>
      </p>
      <p>
        <b>
          <span style="font-size:16.0pt;font-family:宋体;">铝杆连铸连轧生产线</span>
        </b>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">&nbsp;</span>
      </p>
      <p style="text-align:left;" align="left">
        <span style="font-size:12.0pt;font-family:Arial;color:black;">1</span>
        <span style="font-size:12.0pt;font-family:宋体;color:black;">、</span>
        <span style="font-size:12.0pt;font-family:宋体;">铝杆连铸连轧</span>
        <span style="font-size:12.0pt;font-family:宋体;color:black;">生产线用于生产直径为￠</span>
        <span style="font-size:12.0pt;font-family:Arial;color:black;">9.5mm</span>
        <span style="font-size:12.0pt;font-family:宋体;color:black;">、￠</span>
        <span style="font-size:12.0pt;font-family:Arial;color:black;">12mm</span>
        <span
          style="font-size:12.0pt;font-family:宋体;color:black;"
        >的铝杆、铝镁及铝镁硅等高强度导电合金杆，具有与国际同类产品相当的水平。</span>
      </p>
      <p style="text-align:left;" align="left">
        <span style="font-size:12.0pt;font-family:Arial;color:black;">2</span>
        <span
          style="font-size:12.0pt;font-family:宋体;color:black;"
        >、采用带永磁搅拌器的圆形快速节能熔铝炉，便于铝合金的配备、均匀、精炼。</span>
      </p>
      <p style="text-align:left;" align="left">
        <span style="font-size:12.0pt;font-family:Arial;color:black;">3</span>
        <span
          style="font-size:12.0pt;font-family:宋体;color:black;"
        >、采用水平浇铸法，浇铸时铝合金液从中间煲平稳地流向结晶轮，确保铝合金液不产生紊流。</span>
      </p>
      <p style="text-align:left;" align="left">
        <span style="font-size:12.0pt;font-family:Arial;color:black;">4</span>
        <span
          style="font-size:12.0pt;font-family:宋体;color:black;"
        >、连轧机系统采用二辊和三辊相结合的轧制方式，有利于铸锭的轧压及变形。该系统能确保锭坯受力均匀，使铝合金杆获得充分变形，达到性能优，产品质量好。另外连轧机还具有堆杆停车功能。</span>
      </p>
      <p style="text-align:left;" align="left">
        <span style="font-size:12.0pt;font-family:Arial;color:black;">5</span>
        <span style="font-size:12.0pt;font-family:宋体;color:black;">、生产线传动采用西</span>
        <span style="font-size:12pt;font-family:宋体;">门子全数字直流调速装置。控制部分采用</span>
        <span style="font-size:12pt;font-family:Arial;">PLC</span>
        <span
          style="font-size:12pt;font-family:宋体;"
        >准确可靠地指挥协调整个系统的工作，主机和辅机全线联动控制，控制精度高、故障低、维修简单、系统工作稳定可靠。操作采用人机界面，能方便发出操作指令，查看设备运行状况，工艺参数可以通过人机界面设定、修改、显示、并有故障诊断功能。</span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">&nbsp;</span>
      </p>
      <p>
        <br>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      images: {
        lglz: require("../../../assets/img/common/lglz.jpg")
      }
    };
  },

  components: {},

  methods: {}
};
</script>
<style lang='stylus' rel='stylesheet/stylus'>
</style>


// WEBPACK FOOTER //
// src/components/zh/device/lglz.vue